import { Component, forwardRef, Input, Output, EventEmitter, NgModule } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR, FormsModule } from '@angular/forms';
import { AbnormalTypeService } from '../services/abnormal-type.service';
import { CommonModule } from '@angular/common';
import { UISelectBoxModule } from '../select-box/select-box.component';


let /** @type {?} */ noop = () => {
};

export const /** @type {?} */ CUSTOM_INPUT_CONTROL_VALUE_ACCESSOR: any = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => AbnormalSelectComponent),
    multi: true
};
export class AbnormalSelectComponent implements ControlValueAccessor {
  
    
    placeholder = '请选择…';
/**
 * 显示值的标签
 */
label = '';

    
    onChange: EventEmitter<any> = new EventEmitter<any>();
public onTouchedCallback: () => void = noop;
public onChangeCallback: (_: any) => void = noop;
public innerValue;

    dataHandler: Function = this.abnormalTypeService.selectBoxHandler();
    labelHandler: Function = this.abnormalTypeService.selectBoxLabelHandler();
/**
 * @return {?}
 */
get value(): any {
        return this.innerValue;
    };
/**
 * @param {?} v
 * @return {?}
 */
set value(v: any) {
        if (v !== this.innerValue) {
            this.innerValue = v;
            this.onChangeCallback(v);
        }
    }
/**
 * @param {?} abnormalTypeService
 */
constructor(public abnormalTypeService: AbnormalTypeService) {
    }
/**
 * @param {?} value
 * @return {?}
 */
writeValue(value: any) {
        if (value !== this.innerValue) {
            this.innerValue = value;
        }
    }
/**
 * @param {?} fn
 * @return {?}
 */
registerOnChange(fn: any) {
        this.onChangeCallback = fn;
    }
/**
 * @param {?} fn
 * @return {?}
 */
registerOnTouched(fn: any) {
        this.onTouchedCallback = fn;
    }
/**
 * 值改变事件
 * @param {?} val
 * @return {?}
 */
onValueChange(val) {
        this.onChange.emit(val);
    }

static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
    selector: "yzt-abnormal",
    template: `
    <ui-select-box 
        [(ngModel)]="value"
        [label]="label" 
        [placeholder]="placeholder" 
        (onChange)="onValueChange($event)"
        [label-handler]="labelHandler"
        [data-handler]="dataHandler"></ui-select-box>
    `,
    styles: [`
    
    `],
    providers: [CUSTOM_INPUT_CONTROL_VALUE_ACCESSOR]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: AbnormalTypeService, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'placeholder': [{ type: Input },],
'label': [{ type: Input },],
'onChange': [{ type: Output },],
};
}

function AbnormalSelectComponent_tsickle_Closure_declarations() {
/** @type {?} */
AbnormalSelectComponent.decorators;
/**
 * @nocollapse
 * @type {?}
 */
AbnormalSelectComponent.ctorParameters;
/** @type {?} */
AbnormalSelectComponent.propDecorators;
/** @type {?} */
AbnormalSelectComponent.prototype.placeholder;
/**
 * 显示值的标签
 * @type {?}
 */
AbnormalSelectComponent.prototype.label;
/** @type {?} */
AbnormalSelectComponent.prototype.onChange;
/** @type {?} */
AbnormalSelectComponent.prototype.onTouchedCallback;
/** @type {?} */
AbnormalSelectComponent.prototype.onChangeCallback;
/** @type {?} */
AbnormalSelectComponent.prototype.innerValue;
/** @type {?} */
AbnormalSelectComponent.prototype.dataHandler;
/** @type {?} */
AbnormalSelectComponent.prototype.labelHandler;
/** @type {?} */
AbnormalSelectComponent.prototype.abnormalTypeService;
}

export class AbnormalSelectModule { static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
    declarations: [
        AbnormalSelectComponent,
    ],
    exports: [AbnormalSelectComponent],
    imports: [
        CommonModule,
        FormsModule,
        UISelectBoxModule
    ],
    providers:[
        AbnormalTypeService
    ]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function AbnormalSelectModule_tsickle_Closure_declarations() {
/** @type {?} */
AbnormalSelectModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
AbnormalSelectModule.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
